var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"DoujinStand"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v(" DoujinStand ")])]),_c('div',{staticClass:"warp"},[_c('div',{staticClass:"warp-left"},[_vm._v("a")]),_c('div',{staticClass:"warp-right"},[_vm._v("b")])])])])
}]

export { render, staticRenderFns }